export const OWNED_API_URL_PATTERNS = [
  /^https?:\/\/(?:[a-z0-9-]+\.)*kleksi\.(?:com|dev)(?::\d+)?(?:\/|$)/i,
  /^https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?(?:\/|$)/i,
];

export function isOwnedApiUrl(url: string): boolean {
  const absoluteUrl = new URL(url, window.location.origin).href;
  return OWNED_API_URL_PATTERNS.some(pattern => pattern.test(absoluteUrl));
}
